export default "__VITE_ASSET__cf533683__"